import { z } from 'zod';

const requiredMessage = 'Campo obrigatório.';

const nonEmptyStringSchema = z
  .string({ required_error: requiredMessage })
  .min(1, requiredMessage);

const optionalField = z.string().default('').optional();

const placeSchema = z.object({
  place: z.object({
    city: z.object({
      name: nonEmptyStringSchema,
    }),
    state: z.object({
      name: nonEmptyStringSchema,
      acronym: nonEmptyStringSchema,
    }),
    address: optionalField,
    zipCode: optionalField,
  }),
});

const editAddressSchema = z.object({
  delivery: placeSchema,
  pickup: placeSchema,
});

export type EditAddressType = z.infer<typeof editAddressSchema>;

export default editAddressSchema;
